import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getPostKey } from '../../utils/keys';
import { useAuthMember } from '../auth';
import { getCachedRootPostByReplies, infinitePostUpdater, removeReactionFromPost, infinitePostArrayUpdater, } from '../cache/useCachedPost';
import { pinnedPostsFilter, postsQueryFilter } from './filters';
export const useRemoveReaction = (options) => {
    const queryClient = useQueryClient();
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const { data: authMember } = useAuthMember();
    return useMutation((input) => client.posts.removeReaction(input), {
        onMutate: async (variables) => {
            const { reaction, postId } = variables;
            // updating the post itself
            const postKey = getPostKey(postId);
            await queryClient.cancelQueries(postKey);
            const postSnapshot = queryClient.getQueryData(postKey);
            if (postSnapshot) {
                queryClient.setQueryData(postKey, removeReactionFromPost(reaction, authMember.id));
            }
            // updating pinned posts within the space
            const pinnedPostsSnapshot = queryClient.getQueriesData(pinnedPostsFilter);
            if (pinnedPostsSnapshot) {
                queryClient.setQueriesData(pinnedPostsFilter, oldPosts => oldPosts.map(infinitePostArrayUpdater(postId, removeReactionFromPost(reaction, authMember.id), true)));
            }
            // take a snapshot from all matched posts queries
            const postsSnapshots = queryClient.getQueriesData(postsQueryFilter);
            // update posts and replies within the found post everywhere (posts and the feed queries)
            queryClient.setQueriesData(postsQueryFilter, infinitePostUpdater(postId, removeReactionFromPost(reaction, authMember.id), true));
            // updating root post if adding the reaction on a reply if no feed/posts have found
            let rootPostSnapshot;
            let rootPostKey;
            if (!(pinnedPostsSnapshot === null || pinnedPostsSnapshot === void 0 ? void 0 : pinnedPostsSnapshot.length) && !(postsSnapshots === null || postsSnapshots === void 0 ? void 0 : postsSnapshots.length)) {
                const rootPost = getCachedRootPostByReplies(postId, queryClient);
                if (rootPost && rootPost.replies && rootPost.id !== postId) {
                    rootPostKey = getPostKey(rootPost.id);
                    rootPostSnapshot = queryClient.getQueryData(rootPostKey);
                    if (rootPostSnapshot) {
                        queryClient.setQueryData(rootPostKey, infinitePostArrayUpdater(postId, removeReactionFromPost(reaction, authMember.id), true));
                    }
                }
            }
            return [
                [postKey, postSnapshot],
                [rootPostKey, rootPostSnapshot],
                ...pinnedPostsSnapshot,
                ...postsSnapshots,
            ];
        },
        onError: (error, variables, context) => {
            context.forEach(([queryKey, snapshot]) => {
                if (queryKey) {
                    queryClient.setQueryData(queryKey, snapshot);
                }
            });
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useRemoveReaction.js.map